module.exports = __webpack_public_path__ + "img/Synelva_80X30.37f93b66.png";